import { render, staticRenderFns } from "./WpAdminSsoModal.vue?vue&type=template&id=c47b7cea&scoped=true"
import script from "./WpAdminSsoModal.vue?vue&type=script&lang=js"
export * from "./WpAdminSsoModal.vue?vue&type=script&lang=js"
import style0 from "./BasicModal.scss?vue&type=style&index=0&id=c47b7cea&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47b7cea",
  null
  
)

export default component.exports